import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from '@techspert-io/shared';
import { CallSolicitationOutcomePipe } from '../../pipes/call-solicitation-outcome.pipe';
import { CallSolicitationsService } from '../../services/call-solicitations.service';

export interface ICallSolicitationsListDialogData {
  expertId: string;
  expertName: string;
}

@Component({
  selector: 'app-call-solicitations-list-dialog',
  templateUrl: './call-solicitations-list-dialog.component.html',
  imports: [MaterialModule, CallSolicitationOutcomePipe, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallSolicitationsListDialogComponent {
  private readonly callSolicitationsService = inject(CallSolicitationsService);
  readonly data = inject<ICallSolicitationsListDialogData>(MAT_DIALOG_DATA);

  readonly displayedColumns = ['date', 'outcome', 'duration', 'notes'];

  readonly solicitations = rxResource({
    stream: () =>
      this.callSolicitationsService.getByExpertId(this.data.expertId),
  });
}
